import { render } from "./ReportingPerson.vue?vue&type=template&id=780a6e04"
import script from "./ReportingPerson.vue?vue&type=script&lang=js"
export * from "./ReportingPerson.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__